/**
 * Standalone entry point for index.html.
 *
 * Loads the phylocanvas UMD bundle, then calls initStandalone() which kicks
 * off the full application through the ES module graph.
 *
 * phylocanvas.gl is loaded as a vendored UMD script (not an ES import) for two
 * reasons: (1) the npm package's bundle relies on ES2022 static-field define
 * semantics that esbuild downlevels into prototype-chain-violating assignment;
 * (2) the npm version diverges from the bundle the original app shipped, and
 * the user requirement is behavioral parity with that exact bundle.
 */

import { initStandalone } from '../app/app';
import {
  loadClassicScript,
  normalizePhylocanvasGlobals,
} from './bootstrap-utils';

export async function bootstrap(): Promise<void> {
  await loadClassicScript('/js/phylocanvas.gl.min.js');
  normalizePhylocanvasGlobals();

  window.dispatchEvent(new CustomEvent('phylocanvas-loaded'));

  await initStandalone();
}

void bootstrap();
